import Intro from "@/components/intro";
import { VERSA_CONSTANTS } from "./constants";

const VersaSdn = () => {
  return <Intro {...VERSA_CONSTANTS} />;
};

export default VersaSdn;
